import { ChangeRequestWellBase } from './base/change-request-well-base';

export class ChangeRequestWell extends ChangeRequestWellBase { }